export default {"src":"/pro/_next/static/media/doge.0f4c0880.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};